<template>
  <div class="flex-1 flex flex-col w-1/2">
    <div class="h-full">
      <textarea id="output"></textarea>
    </div>
  </div>
</template>

<script>
import { saveAs } from 'file-saver';

import "codemirror/addon/fold/foldgutter.css";
import "codemirror/theme/material.css";
import "codemirror/theme/solarized.css";
import "codemirror/theme/dracula.css";

const CodeMirror = require("codemirror/lib/codemirror");

require("codemirror/keymap/sublime");
require("codemirror/addon/comment/comment");
require("codemirror/addon/search/searchcursor");
require("codemirror/addon/fold/foldcode");
require("codemirror/addon/fold/foldgutter");
require("codemirror/addon/fold/indent-fold");
require("codemirror/addon/fold/brace-fold");
require("codemirror/addon/mode/overlay");
require("codemirror/mode/htmlmixed/htmlmixed");
require("codemirror/mode/xml/xml");
require("codemirror/mode/clike/clike");
require("codemirror/mode/php/php");

CodeMirror.defineMode("ansi", function(config, parserConfig) {
  var ansiOverlay = {
    token: function(stream, state) {
      var ch;
      if (stream.match("[43m")) {
        while ((ch = stream.next()) != null)
          if (
            ch == "[" &&
            stream.next() == "4" &&
            stream.next() == "9" &&
            stream.next() == "m"
          ) {
            stream.eat("4");
            return "warning";
          }
      }
      if (stream.match("[41m")) {
        while ((ch = stream.next()) != null)
          if (
            ch == "[" &&
            stream.next() == "4" &&
            stream.next() == "9" &&
            stream.next() == "m"
          ) {
            stream.eat("4");
            return "error";
          }
      }
      while (
        stream.next() != null &&
        !stream.match("[43m", false) &&
        !stream.match("[41m", false)
      ) {}
      return null;
    }
  };
  return CodeMirror.overlayMode(
    CodeMirror.getMode(config, parserConfig.backdrop || "text/x-php"),
    ansiOverlay
  );
});


import PhpLoading from './PhpLoading.vue';
import PhpError from './PhpError.vue';

export default {
  name: 'Output',
  components: {
    PhpError,
    PhpLoading,
  },
  props: {
    value: String,
  },
  data() {
    return {
      outputJson: null,
      outputError: null,
      editor: null,
    };
  },

  computed: {
    phpLoaded() {
      return this.$store.state.Code.phpLoaded;
    },
    theme() {
      return this.$store.state.Code.theme;
    },
    lineHeight() {
      return this.$store.state.Code.lineHeight;
    },
    fontSize() {
      return this.$store.state.Code.fontSize;
    },
    font() {
      return this.$store.state.Code.font;
    },
    lineNumbers() {
      return this.$store.state.Code.lineNumbers;
    },
    lineWrapping() {
      return this.$store.state.Code.lineWrapping;
    },
  },

  watch: {
    theme(value) {
      this.editor.setOption("theme", value.toLowerCase());
      this.editor.refresh();
    },
    lineNumbers(value) {
      this.editor.setOption("lineNumbers", value);
    },
    lineWrapping(value) {
      this.editor.setOption("lineWrapping", value);
    },
    lineHeight(value) {
      this.editor.getWrapperElement().style.lineHeight = value;
      this.editor.refresh();
    },
    font(value) {
      this.editor.getWrapperElement().style.fontFamily = value;
      this.editor.refresh();
    },
    fontSize(value) {
      this.editor.getWrapperElement().style.fontSize = value + "px";
      this.editor.refresh();
    },
    value(data) {
      this.outputJson = data;
    },
  },

  methods: {

    loadSettings() {
      this.editor.setOption("theme", this.theme.toLowerCase());
      this.editor.getWrapperElement().style.lineHeight = this.lineHeight;
      this.editor.getWrapperElement().style.fontSize = this.fontSize+"px";
      this.editor.setOption("lineNumbers", this.lineNumbers);
      this.editor.setOption("lineWrapping", this.lineWrapping);
      this.editor.refresh();
    },

  },

  mounted() {


    this.editor = CodeMirror.fromTextArea(document.getElementById("output"), {
      mode: "ansi",
      lineNumbers: true,
      lineWrapping: false,
      theme: 'dracula',
      gutters: ["CodeMirror-linenumbers", "CodeMirror-foldgutter"],
      foldGutter: true,
      readOnly: true
    });

    this.editor.on("renderLine", function(cm, line, element) {
      const regex = /(\[(43|41)m)(.*?)(\[49m)/gm;
      let value = element.innerHTML;
      if (regex.exec(value) !== null) {
        element.innerHTML = value.replace(regex, "$3");
      }
    });

    this.editor.getWrapperElement().style.fontFamily = 'Fira Code';
    this.editor.refresh();

    this.loadSettings()

   this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'loadSnippet') {
        this.editor.getDoc().setValue(mutation.payload.output);
      }
    });
  },
  created() {
    if (!window.isSupportedBrowser) {
      this.$store.dispatch("setPHPLoaded", true);
      this.outputError = {
        type: 'Browser Not Supported',
        message: `To use Tinkerwell, a recent desktop browser version supporting web assembly is required.

Chrome: >= v60
Firefox: >= v60
Safari: >= v13
`
      }
      return;
    }

    this.$root.$on('php.loaded', () => {
      this.$store.dispatch("setPHPLoaded", true);
    });

    this.$root.$on('php.print', (lines) => {
      this.outputJson = lines;

      this.editor.getDoc().setValue(this.outputJson);
    });
  },
};
</script>

<style scoped>
  .vue-codemirror {
    width: 100% !important;
    height: 100% !important;
  }

  .CodeMirror {
    width: 100% !important;
    height: 100% !important;
  }
.cm-error {
  color: red;
}

.cm-warning {
  color: yellow;
}
</style>
